// extracted by mini-css-extract-plugin
export default {"CancellationReasonContainer":"_CancellationReasonContainer--VRJrn","CancellationReasonButton":"_CancellationReasonButton--L5qxg"};